import { combineReducers } from 'redux';

import account from './account';
import customization from './customization';
import customizelexicon from './lexicon';
import keys from './keys';
import recognition from './recognition';
import recognitions from './recognitions';
import rmi from './rmi';
import session from './session';
import status from './status';


/* This is the place where the global state gets compiled
from all the individual slices of state. New reducers must
 be registered here to be accessible in the global state */

export default combineReducers({
  account,
  customization,
  customizelexicon,
  keys,
  recognition,
  recognitions,
  rmi,
  session,
  status,
});
